exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.screenfull-svg[data-v-29234bee] {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tfill: #5a5e66;\n\twidth: 20px;\n\theight: 20px;\n\tvertical-align: 10px;\n}\n", ""]);

// exports
